import { useState, useEffect } from "react";
import axios from "axios";

export default function RequestCash({ onSuccess }) {
  const [form, setForm] = useState({
    relocation_id: "",
    request_type: "",
    amount: "",
    remark: "",
    approval_status: "Requested",
  });
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const baseAPI = process.env.REACT_APP_API_URL;
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const headers = {
    Authorization: `Bearer ${storedToken}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    const fetchExpenseTypes = async () => {
      try {
        const res = await axios.get(`${baseAPI}adminGet/GetRequestType`, { headers });
        setExpenseTypes(res.data.data || []);
      } catch (err) {
        console.error("Failed to load request types", err);
      }
    };
    fetchExpenseTypes();
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (!form.request_type || !form.amount) {
      alert("Please fill all required fields");
      return;
    }

    const payload = {
      ...form,
      request_type: parseInt(form.request_type),
      amount: parseFloat(form.amount),
      relocation_id: form.relocation_id ? parseInt(form.relocation_id) : "",
    };

    setLoading(true);
    try {
      const res = await axios.post(
        `${baseAPI}UserPost/InsertUpdateCmpPettyCash`,
        payload,
        { headers }
      );

      if (res.status === 200) {
        alert("Expense saved successfully!");
        setForm({
          relocation_id: "",
          request_type: "",
          amount: "",
          remark: "",
          approval_status: "Requested",
        });
        if (onSuccess) onSuccess(); // trigger list refresh in parent
      } else {
        alert("Error saving expense!");
      }
    } catch (err) {
      console.error("Error saving expense:", err.response?.data || err.message);
      alert("Error saving expense!");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%", padding: "10px 12px", border: "1px solid #d0c8f0",
    borderRadius: 8, fontSize: 13, color: "#333", outline: "none",
    boxSizing: "border-box", background: "#fff",
  };

  return (
    <div style={{ padding: 14, background: "#fff" }}>
      <div style={{ marginBottom: 12 }}>
        <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>Lead ID</label>
        <input
          style={inputStyle}
          name="relocation_id"
          type="number"
          placeholder="Enter"
          value={form.relocation_id}
          onChange={handleChange}
        />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
        <div>
          <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>Amount</label>
          <input
            style={inputStyle}
            name="amount"
            type="number"
            placeholder="Enter"
            value={form.amount}
            onChange={handleChange}
          />
        </div>
        <div>
          <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>Request Type</label>
          <div style={{ position: "relative" }}>
            <select
              name="requestType"
              value={form.request_type}
              onChange={(e) => setForm({ ...form, request_type: e.target.value })}
              style={{ ...inputStyle, appearance: "none" }}
            >
              <option value="">Select</option>
              {expenseTypes.map((exp) => (
                <option key={exp.request_type_id} value={exp.request_type_id}>
                  {exp.request_type}
                </option>
              ))}
            </select>
            <svg
              style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
              width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ fontSize: 11, color: "#888", display: "block", marginBottom: 4 }}>
          Remark <span style={{ color: "#aaa", fontStyle: "italic" }}>(If Any)</span>
        </label>
        <textarea
          name="remark"
          placeholder="...."
          value={form.remark}
          onChange={handleChange}
          style={{ ...inputStyle, resize: "none", minHeight: 80 }}
        />
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading}
        style={{
          width: "100%", padding: 13, background: loading ? "#9990d4" : "#534AB7",
          color: "#fff", border: "none", borderRadius: 8, fontSize: 13,
          fontWeight: 500, cursor: loading ? "not-allowed" : "pointer", letterSpacing: "0.5px",
        }}
      >
        {loading ? "SUBMITTING..." : "SUBMIT"}
      </button>
    </div>
  );
}